import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import config from "../config/config";
import Header from "../directives/header";
import Footer from "../directives/footer";
import { Container, Row, Col, Form, Button, Dropdown } from "react-bootstrap";
import { Zoom, Fade, Slide, Roll } from "react-reveal";
import Tree from "react-d3-tree";
import { TextField, Box } from "@mui/material";
import "../custom-tree.css";

import Dashboardheader from "../directives/dashboardheader";

const Changepassword = () => {
  const orgChart = {
    name: "CEO",
    children: [
      {
        name: "Manager",
        attributes: {
          department: "Production",
        },
        children: [
          {
            name: "Foreman",
            attributes: {
              department: "Fabrication",
            },
            children: [
              {
                name: "Worker",
              },
            ],
          },
          {
            name: "Foreman",
            attributes: {
              department: "Assembly",
            },
            children: [
              {
                name: "Worker",
              },
            ],
          },
        ],
      },
    ],
  };
  return (
    <>
      <Dashboardheader />
      <div className="shape_bg">
          <img src="assets/images/shape.svg" className="shape" />
          <img src="assets/images/shape1.svg" className="shape1" />
          <img src="assets/images/shape2.svg" className="shape2" />
          {/* <img src="assets/images/shape.svg" className="shape3" />
          <img src="assets/images/shape1.svg" className="shape4" /> */}
        </div>
      <div className="page-wrapper">
        <div className="position-relative overflow-hidden mt-5 pt-2 mb-5">
          <div className="mb-4">
            <Container className="">
              <Row>
                <Col lg={12}>
                  <h1 className="text-gradient">Change Your Password </h1>
                </Col>
              </Row>
            </Container>
          </div>
          <div className="changepassword mb-5">
            <Container className="">
              <Row>
                <Col lg={12}>
                  <div className="card card-view1 rounded-20 p-4">
                    <div className="card-body p-3">
                      <Row className="align-items-center">
                        <Col lg={6} className="mb-3">
                          <div>
                            <img
                              src="assets/images/key.png"
                              width="100%"
                              className="key_img"
                            />
                          </div>
                        </Col>
                        <Col lg={6} className="mb-3">
                          <div className="card-view1 rounded-20 p-4">
                            <Row>
                              <Col lg={7} md={8} sm={8}>
                                <h4 className="text-white">
                                  <b>Change Password</b>
                                </h4>
                                <p>
                                  Just type it twist and try not to forget it.
                                  Password should be and must contain.
                                </p>
                              </Col>
                              <Col lg={5} md={4} sm={4}>
                                <div
                                  className="text-center lock"
                                >
                                  <img src="assets/images/lock.png" />
                                </div>
                              </Col>
                              <Col lg={12}>
                                <div>
                                  <ul>
                                    <li>
                                      <div>
                                        <h5 className="text-white mb-0">
                                          <b>8+</b>
                                        </h5>
                                        <h6 className="text-grey mt-1">Characters</h6>
                                      </div>
                                    </li>
                                    <li>
                                      <div>
                                        <h5 className="text-white mb-0">
                                          <b>AA</b>
                                        </h5>
                                        <h6 className="text-grey mt-1">Uppercase</h6>
                                      </div>
                                    </li>
                                    <li>
                                      <div>
                                        <h5 className="text-white mb-0">
                                          <b>aa</b>
                                        </h5>
                                        <h6 className="text-grey mt-1">Lowercase</h6>
                                      </div>
                                    </li>
                                    <li>
                                      <div>
                                        <h5 className="text-white mb-0">
                                          <b>123</b>
                                        </h5>
                                        <h6 className="text-grey mt-1">Number</h6>
                                      </div>
                                    </li>
                                    <li>
                                      <div>
                                        <h5 className="text-white mb-0">
                                          <b>@$# </b>
                                        </h5>
                                        <h6 className="text-grey mt-1">Symbol</h6>
                                      </div>
                                    </li>
                                  </ul>
                                </div>
                              </Col>
                              <Col lg={12} className="mb-4">
                                <div className="mb-4">
                                  <TextField
                                    id="outlined-helperText"
                                    label="Enter Your Old Password"
                                    type="password"
                                    style={{ width: "100%" }}
                                    InputLabelProps={{
                                      shrink: true,
                                    }}
                                    autoComplete="off"
                                  />
                                </div>
                                <div className="mb-4">
                                  <TextField
                                    id="outlined-helperText"
                                    label="Enter New Password"
                                    type="password"
                                    style={{ width: "100%" }}
                                    InputLabelProps={{
                                      shrink: true,
                                    }}
                                    autoComplete="off"
                                  />
                                </div>
                                <div className="mb-4">
                                  <TextField
                                    id="outlined-helperText"
                                    label="Confirm Password"
                                    type="password"
                                    style={{ width: "100%" }}
                                    InputLabelProps={{
                                      shrink: true,
                                    }}
                                    autoComplete="off"
                                  />
                                </div>
                                <Button variant="main2" className="w-100">
                                  Change Password
                                </Button>
                              </Col>
                              <Col lg={12} className="">
                                <div className="social-icon text-center">
                                  <a href="#">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={36}
                                      height={36}
                                      viewBox="0 0 36 36"
                                      fill="none"
                                    >
                                      <circle
                                        cx={18}
                                        cy={18}
                                        r="17.5"
                                        stroke="url(#paint0_linear_365_1851)"
                                        strokeOpacity="0.5"
                                      />
                                      <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M21.8215 12.4395C21.2798 12.3311 20.5482 12.2502 20.0881 12.2502C18.8422 12.2502 18.7613 12.7919 18.7613 13.6586V15.2015H21.8757L21.6042 18.3975H18.7613V28.1187H14.8617V18.3975H12.8574V15.2015H14.8617V13.2246C14.8617 10.5167 16.1344 9 19.3297 9C20.4399 9 21.2524 9.16251 22.3084 9.37919L21.8215 12.4395Z"
                                        fill="#D3D3D3"
                                      />
                                      <defs>
                                        <linearGradient
                                          id="paint0_linear_365_1851"
                                          x1="0.818181"
                                          y1="21.6"
                                          x2="29.0916"
                                          y2="34.425"
                                          gradientUnits="userSpaceOnUse"
                                        >
                                          <stop stopColor="#41D2FF" />
                                          <stop
                                            offset="0.473958"
                                            stopColor="#7E42FF"
                                          />
                                          <stop
                                            offset="0.961901"
                                            stopColor="#DD3FFF"
                                          />
                                        </linearGradient>
                                      </defs>
                                    </svg>
                                  </a>
                                  <a href="#">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={36}
                                      height={36}
                                      viewBox="0 0 36 36"
                                      fill="none"
                                    >
                                      <circle
                                        cx={18}
                                        cy={18}
                                        r="17.5"
                                        stroke="url(#paint0_linear_365_1855)"
                                        strokeOpacity="0.5"
                                      />
                                      <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M28.5706 11.0063C27.8039 11.3469 26.9787 11.5763 26.1132 11.6799C26.9968 11.1502 27.6753 10.3118 27.9943 9.31283C27.1685 9.80363 26.2515 10.1589 25.2776 10.3514C24.4969 9.51999 23.3839 9 22.1541 9C19.7912 9 17.8753 10.9159 17.8753 13.2788C17.8753 13.6139 17.9135 13.9406 17.9865 14.2542C14.43 14.0762 11.2774 12.3723 9.16679 9.78347C8.79835 10.4154 8.58771 11.1502 8.58771 11.9344C8.58771 13.4186 9.34198 14.7283 10.4911 15.4958C9.78898 15.4735 9.12995 15.281 8.55225 14.9605V15.014C8.55225 17.0877 10.0281 18.8166 11.9844 19.2108C11.6256 19.3081 11.2475 19.361 10.8575 19.361C10.5815 19.361 10.3131 19.3338 10.0518 19.2838C10.5961 20.9835 12.1769 22.2209 14.049 22.2557C12.585 23.4027 10.74 24.0875 8.73508 24.0875C8.38889 24.0875 8.04825 24.0673 7.71387 24.027C9.60754 25.2408 11.8564 25.9499 14.2729 25.9499C22.143 25.9499 26.4469 19.4298 26.4469 13.7759C26.4469 13.5903 26.4434 13.4054 26.4344 13.2225C27.2714 12.6177 27.9971 11.8641 28.5706 11.0063Z"
                                        fill="#D3D3D3"
                                      />
                                      <defs>
                                        <linearGradient
                                          id="paint0_linear_365_1855"
                                          x1="0.818181"
                                          y1="21.6"
                                          x2="29.0916"
                                          y2="34.425"
                                          gradientUnits="userSpaceOnUse"
                                        >
                                          <stop stopColor="#41D2FF" />
                                          <stop
                                            offset="0.473958"
                                            stopColor="#7E42FF"
                                          />
                                          <stop
                                            offset="0.961901"
                                            stopColor="#DD3FFF"
                                          />
                                        </linearGradient>
                                      </defs>
                                    </svg>
                                  </a>
                                  <a href="#">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={36}
                                      height={36}
                                      viewBox="0 0 36 36"
                                      fill="none"
                                    >
                                      <circle
                                        cx={18}
                                        cy={18}
                                        r="17.5"
                                        stroke="url(#paint0_linear_365_1861)"
                                        strokeOpacity="0.5"
                                      />
                                      <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M13.1494 10.9848C13.1494 12.0668 12.3255 12.9425 11.0371 12.9425C9.79895 12.9425 8.97508 12.0668 9.00058 10.9848C8.97508 9.85016 9.79893 9 11.0618 9C12.3255 9 13.1247 9.85016 13.1494 10.9848ZM9.10416 27.0924V14.489H13.0211V27.0916H9.10416V27.0924Z"
                                        fill="#D3D3D3"
                                      />
                                      <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M16.1602 18.5104C16.1602 16.9384 16.1084 15.5982 16.0566 14.4899H19.4589L19.6397 16.2165H19.717C20.2326 15.4173 21.521 14.207 23.6085 14.207C26.1853 14.207 28.1183 15.9082 28.1183 19.6179V27.0933H24.2013V20.1088C24.2013 18.4841 23.6348 17.3766 22.2173 17.3766C21.1345 17.3766 20.4907 18.124 20.2334 18.8451C20.1298 19.1032 20.0788 19.4634 20.0788 19.8251V27.0933H16.1618V18.5104H16.1602Z"
                                        fill="#D3D3D3"
                                      />
                                      <defs>
                                        <linearGradient
                                          id="paint0_linear_365_1861"
                                          x1="0.818181"
                                          y1="21.6"
                                          x2="29.0916"
                                          y2="34.425"
                                          gradientUnits="userSpaceOnUse"
                                        >
                                          <stop stopColor="#41D2FF" />
                                          <stop
                                            offset="0.473958"
                                            stopColor="#7E42FF"
                                          />
                                          <stop
                                            offset="0.961901"
                                            stopColor="#DD3FFF"
                                          />
                                        </linearGradient>
                                      </defs>
                                    </svg>
                                  </a>
                                  <a href="#">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={36}
                                      height={36}
                                      viewBox="0 0 36 36"
                                      fill="none"
                                    >
                                      <circle
                                        cx={18}
                                        cy={18}
                                        r="17.5"
                                        stroke="url(#paint0_linear_365_1868)"
                                        strokeOpacity="0.5"
                                      />
                                      <path
                                        d="M18.1423 9.59333C20.9267 9.59333 21.2566 9.60397 22.3562 9.65414C23.373 9.70051 23.9252 9.87039 24.2926 10.0132C24.7794 10.2024 25.1268 10.4284 25.4917 10.7933C25.8566 11.1582 26.0826 11.5056 26.2718 11.9924C26.4146 12.3598 26.5845 12.912 26.6308 13.9288C26.681 15.0284 26.6917 15.3582 26.6917 18.1427C26.6917 20.9272 26.681 21.257 26.6308 22.3567C26.5845 23.3734 26.4146 23.9256 26.2718 24.2931C26.0826 24.7798 25.8566 25.1272 25.4917 25.4921C25.1268 25.8571 24.7794 26.083 24.2926 26.2722C23.9252 26.415 23.373 26.5849 22.3562 26.6313C21.2568 26.6814 20.927 26.6921 18.1423 26.6921C15.3576 26.6921 15.0278 26.6814 13.9283 26.6313C12.9115 26.5849 12.3594 26.415 11.9919 26.2722C11.5051 26.083 11.1577 25.8571 10.7928 25.4921C10.4279 25.1272 10.2019 24.7798 10.0127 24.2931C9.86991 23.9256 9.70003 23.3734 9.65366 22.3567C9.60349 21.257 9.59285 20.9272 9.59285 18.1427C9.59285 15.3582 9.60349 15.0284 9.65366 13.9288C9.70003 12.912 9.86991 12.3598 10.0127 11.9924C10.2019 11.5056 10.4279 11.1582 10.7928 10.7933C11.1577 10.4284 11.5051 10.2024 11.9919 10.0132C12.3594 9.87039 12.9115 9.70051 13.9283 9.65414C15.0279 9.60397 15.3578 9.59333 18.1423 9.59333ZM18.1423 7.71436C15.3101 7.71436 14.9549 7.72636 13.8426 7.77711C12.7327 7.82774 11.9746 8.00404 11.3113 8.26181C10.6255 8.52831 10.0439 8.88489 9.46415 9.46464C8.88441 10.0444 8.52783 10.626 8.26136 11.3117C8.00355 11.9751 7.82725 12.7331 7.77662 13.8431C7.72587 14.9554 7.71387 15.3105 7.71387 18.1427C7.71387 20.9749 7.72587 21.33 7.77662 22.4423C7.82725 23.5523 8.00355 24.3104 8.26136 24.9737C8.52783 25.6594 8.88441 26.241 9.46415 26.8208C10.0439 27.4005 10.6255 27.7571 11.3113 28.0236C11.9746 28.2814 12.7327 28.4577 13.8426 28.5083C14.9549 28.5591 15.3101 28.5711 18.1423 28.5711C20.9744 28.5711 21.3296 28.5591 22.4419 28.5083C23.5518 28.4577 24.3099 28.2814 24.9732 28.0236C25.659 27.7571 26.2406 27.4005 26.8204 26.8208C27.4001 26.241 27.7567 25.6594 28.0232 24.9737C28.281 24.3104 28.4573 23.5523 28.5079 22.4423C28.5586 21.33 28.5706 20.9749 28.5706 18.1427C28.5706 15.3105 28.5586 14.9554 28.5079 13.8431C28.4573 12.7331 28.281 11.9751 28.0232 11.3117C27.7567 10.626 27.4001 10.0444 26.8204 9.46464C26.2406 8.88489 25.659 8.52831 24.9732 8.26181C24.3099 8.00404 23.5518 7.82774 22.4419 7.77711C21.3296 7.72636 20.9744 7.71436 18.1423 7.71436Z"
                                        fill="#D3D3D3"
                                      />
                                      <path
                                        d="M18.1462 12.792C15.1886 12.792 12.791 15.1895 12.791 18.1471C12.791 21.1047 15.1886 23.5022 18.1462 23.5022C21.1037 23.5022 23.5012 21.1047 23.5012 18.1471C23.5012 15.1895 21.1037 12.792 18.1462 12.792ZM18.1462 21.6232C16.2263 21.6232 14.67 20.0669 14.67 18.1471C14.67 16.2273 16.2263 14.671 18.1462 14.671C20.066 14.671 21.6223 16.2273 21.6223 18.1471C21.6223 20.0669 20.066 21.6232 18.1462 21.6232Z"
                                        fill="#D3D3D3"
                                      />
                                      <path
                                        d="M24.9647 12.5766C24.9647 13.2677 24.4044 13.828 23.7133 13.828C23.0222 13.828 22.4619 13.2677 22.4619 12.5766C22.4619 11.8855 23.0222 11.3252 23.7133 11.3252C24.4044 11.3252 24.9647 11.8855 24.9647 12.5766Z"
                                        fill="#D3D3D3"
                                      />
                                      <defs>
                                        <linearGradient
                                          id="paint0_linear_365_1868"
                                          x1="0.818181"
                                          y1="21.6"
                                          x2="29.0916"
                                          y2="34.425"
                                          gradientUnits="userSpaceOnUse"
                                        >
                                          <stop stopColor="#41D2FF" />
                                          <stop
                                            offset="0.473958"
                                            stopColor="#7E42FF"
                                          />
                                          <stop
                                            offset="0.961901"
                                            stopColor="#DD3FFF"
                                          />
                                        </linearGradient>
                                      </defs>
                                    </svg>
                                  </a>
                                </div>
                              </Col>
                            </Row>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </div>
                </Col>
              </Row>
            </Container>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};
export default Changepassword;
